import { useCallback, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { Form, useForm } from '@campai/lib-web/components'
import {
    Button,
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    Field,
    FieldLabel,
    Input,
} from '@campai/lib-web/components/new/ui'
import { client } from '@campai/lib-web/utils/trpc'

export const EmailChangeDialog = observer(
    ({ close, onUpdate }: { close: () => void; onUpdate: (newEmail: string) => void }) => {
        const { t } = useTranslation()
        const { formProps, formRef, isSubmittingForm } = useForm()
        const [newEmail, setNewEmail] = useState('')

        const handleSubmit = useCallback(async () => {
            await client.currentUser.updateUserEmail.mutate({ email: newEmail })
            onUpdate(newEmail)
            close()
        }, [close, newEmail, onUpdate])

        return (
            <Dialog open onOpenChange={(open) => !open && !isSubmittingForm && close()}>
                <DialogContent showCloseButton={false}>
                    <DialogHeader>
                        <DialogTitle>{t('profile.emailChangeDialog.title')}</DialogTitle>
                    </DialogHeader>
                    <Form {...formProps} onSubmit={handleSubmit}>
                        <Field>
                            <FieldLabel htmlFor="user-profile-new-email" required>
                                {t('profile.emailChangeDialog.email')}
                            </FieldLabel>
                            <Input
                                id="user-profile-new-email"
                                type="email"
                                required
                                value={newEmail}
                                onChange={(event) => setNewEmail(event.target.value)}
                            />
                        </Field>
                    </Form>
                    <DialogFooter>
                        <Button type="button" variant="outline" disabled={isSubmittingForm} onClick={close}>
                            {t('actions.cancel')}
                        </Button>
                        <Button
                            type="button"
                            loading={isSubmittingForm}
                            disabled={isSubmittingForm}
                            onClick={() => void formRef.current?.submit()}
                        >
                            {t('profile.emailChangeDialog.save')}
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        )
    }
)
